import React, { useState, useRef, useEffect } from 'react';
import AuctionCard from '../auction-card/component';
import { Stack, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '../../../constants/route-constants';
import NoData from '../no-data';
import InfiniteScroll from 'react-infinite-scroller';
import useInitialData from '../../../utils/use-initial-data';
import SkeletonLoader from '../../common/skeleton-loader';
import PropTypes from 'prop-types';
import RefreshIcon from '@mui/icons-material/Refresh';
import { PAGE_SIZE } from '../../../constants/app-constants';
import { prepareGADataAndSendEvent } from '../../../tracking';

const MyWatchList = ({ user, watchList, fetchWatchListsConnect }) => {
    const { shortlistedVehicles: watchLists, total = 0 } = watchList || {};
    const [loading, setLoading] = useState(false);
    const ref = useRef({ currentPage: 0, pageSize: PAGE_SIZE });
    const navigate = useNavigate();
    const handleCardClick = (auctionId) => {
        navigate(`${ROUTE_PATH.WATCH_LIST}${ROUTE_PATH.AUCTION_DETAILS}?aid=${auctionId}`);
    };

    const makePayload = () => {
        return { page: ref.current.currentPage, size: ref.current.pageSize };
    };

    useEffect(() => {
        if (total) {
            prepareGADataAndSendEvent('watchListPage', user, null, '', { eventLabel: total });
        }
    }, [total, user]);

    useInitialData({
        setLoading,
        fetchData: fetchWatchListsConnect,
        payload: makePayload()
    });

    const loadMoreData = async () => {
        try {
            if (watchLists?.length < total && (ref.current.currentPage + 1) === (watchLists?.length / ref.current.pageSize)) {
                setLoading(true);
                ref.current.currentPage += 1;
                const payload = makePayload();
                fetchWatchListsConnect(payload, true).finally(() => setLoading(false));
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const handleRefresh = () => {
        setLoading(true);
        ref.current.currentPage = 0;
        fetchWatchListsConnect(makePayload()).finally(() => setLoading(false));
    };

    const handleSubTitleClick = () => {
        navigate(`${ROUTE_PATH.EXPLORE}`);
    };
    const isDataAvailable = (watchLists && watchLists?.length > 0);

    const title = !isDataAvailable ? 'Please add Cars to your watch list to view this page.' : `Oops ! You haven't added any Cars to your watch list yet.`;
    return (
        <React.Fragment>
            <Stack direction={'row'} spacing={2} alignItems="center" justifyContent={'flex-end'} className='mb-2'>
                <Button size='small' onClick={handleRefresh} className='bg-light-border text-text' startIcon={<RefreshIcon />}>
                    Refresh
                </Button>
            </Stack>
            {isDataAvailable &&
                <React.Fragment>
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={loadMoreData}
                        threshold={50}
                        hasMore={!!watchLists?.length < total}
                    >
                        <Stack spacing={3} direction={'column'}>
                            {watchLists?.map((auction, index) => (
                                <AuctionCard key={index} isWatchList={true} auction={auction} handleCardClick={handleCardClick.bind(null, auction?.appointmentId)} />
                            ))}
                        </Stack>
                    </InfiniteScroll>
                </React.Fragment>
            }
            {loading && <SkeletonLoader />}
            {!isDataAvailable && !loading && <NoData handleRefresh={handleRefresh} subTitleClass="text-lg mt-8 text-primary" title={title} subTitle={'View live auctions running.'} handleSubTitleClick={handleSubTitleClick} />}
        </React.Fragment>
    );
};

MyWatchList.propTypes = {
    user: PropTypes.object,
    watchList: PropTypes.object,
    fetchWatchListsConnect: PropTypes.func
};

export default MyWatchList;
